<template>
  <div class="industury">
    <router-view />
    <div class="industury__topbanner">
    <ul v-if="$root.globalData">
        <li>{{$root.globalData.keys.contact_us_text}}</li>
        <span> <DoubleLeftAroow /> </span>
        <li>
          <router-link style="color: white" to="/"> {{$root.globalData.keys.home_index_text}} </router-link>
        </li>
      </ul>
    </div>

    <section class="contact__us w margin drRtl">
      
      <div v-if="$root.globalData" class="rightBox">
        <h3><BulletIcon /> {{$root.globalData.keys.text_contact_us}}:</h3>
        <p>
          <PhoneBlueIcon /> <span> {{$root.globalData.settings.footer_phone}} </span>
          <span>{{`${$root.globalData.keys.fax_text}:${$root.globalData.settings.fax}`}} </span>
        </p>
        <p><EmailBlueIcon /> {{$root.globalData.settings.email}}</p>
        <p><ClockBlueIcon /> {{$root.globalData.keys.aboutus_response_time}}</p>
      </div>

      <div class="leftBox">
        <img class="locationImage" :src="LocationImage" alt="location" />
        <p v-if="$root.globalData">{{$root.globalData.keys.followus_on_socialmedia}}</p>

        <div class="contact__social">
          <span> <TelegtamDarkIcon /> </span>
          <span> <WhatsappDarkIcon /> </span>
          <span> <TwitterDarkIcon /> </span>
          <span> <InstagramDarkIcon /> </span>
        </div>
      </div>

    </section>
  </div>
</template> 


<script>
import DoubleLeftAroow from "../components/svgs/DoubleLeftAroow.vue";
import IndusturyFilter from "../components/main/IndusturyFilter.vue";
// import RateFilter from "../components/main/RateFilter.vue";
import BlogSliderFilter from "../components/main/BlogSliderFilter.vue";
import ArrowDown from "../components/svgs/ArrowDown.vue";
import HamburgetMenuIcon3 from "../components/svgs/HamburgetMenuIcon3.vue";
import HamburgerMenuIcon2 from "../components/svgs/HamburgerMenuIcon2.vue";
import BulletIcon from "../components/svgs/BulletIcon.vue";
import TelIcon from "../components/svgs/TelIcon.vue";
import PhoneBlueIcon from "../components/svgs/PhoneBlueIcon.vue";
import EmailBlueIcon from "../components/svgs/EmailBlueIcon.vue";
import ClockBlueIcon from "../components/svgs/ClockBlueIcon.vue";
import Image from "../assets/images/googlemap.jpg";
import TelegtamDarkIcon from "../components/svgs/TelegtamDarkIcon.vue";
import WhatsappDarkIcon from "../components/svgs/WhatsappDarkIcon.vue";
import TwitterDarkIcon from "../components/svgs/TwitterDarkIcon.vue";
import InstagramDarkIcon from "../components/svgs/InstagramDarkIcon.vue";

export default {
  data() {
    return {
      LocationImage: Image,
    };
  },

  methods: {
    cardbox() {
      // this.ShowingCard =
    },

    CardBoxShow() {},
  },
  components: {
    DoubleLeftAroow,
    IndusturyFilter,
    // RateFilter,
    BlogSliderFilter,
    ArrowDown,
    HamburgetMenuIcon3,
    HamburgerMenuIcon2,
    BulletIcon,
    TelIcon,
    PhoneBlueIcon,
    EmailBlueIcon,
    ClockBlueIcon,
    TelegtamDarkIcon,
    WhatsappDarkIcon,
    TwitterDarkIcon,
    InstagramDarkIcon,
  },
  
  metaInfo() {
        return { 
            title: "تماس با ما",
            meta: [
                { name: 'description', content:  'تماس با ما'},
                { property: 'og:title', content: "تماس با ما"},
                {property: 'og:type', content: 'website'},    
                {name: 'robots', content: 'index,follow'} 
            ]
        }
    }
};
</script>


<style scoped>
.industury {
  background-color: #f1f0f0;
}
.industury__topbanner {
  width: 100%;
  height: 200px;
  background-image: url(../assets/images/industrybanner.jpg);
  background-color: rgba(0, 0, 0, 0.7);
  background-blend-mode: multiply;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}

.industury__topbanner ul {
  display: flex;
  align-items: center;
  justify-content: center;
}

.industury__topbanner ul li {
  font-size: 20px;
  cursor: pointer;
}

/* about body styles  */

.contact__us {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  padding: 2rem 0;
}

.rightBox {
  text-align: right;
  grid-column: 1/ 10;
}

.rightBox h3 {
  display: flex;
  align-items: center;
  padding-bottom: 4rem;
}

.rightBox p {
  display: flex;
  align-items: center;
  margin-bottom: 4rem;
}
.rightBox p span {
  padding: 0 10px;
}
.leftBox {
  text-align: center;
  grid-column: 10/ -1;
}

.leftBox p {
  word-spacing: 2px;
  font-size: 18px;
  padding: 1rem 0;
}

.locationImage {
  border-radius: 10px;
  width: 100%;
}
</style> 


